module.exports = __webpack_public_path__ + "static/img/tcqn5.32df029.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tcqn5.png
// module id = 384
// module chunks = 0